import React from 'react';
import { SimpleTextLayoutProps } from 'ui-builder';

import styles from './TextLayout.module.scss';

export default function TextLayout(
  props: SimpleTextLayoutProps,
) {
  return (
    <span
      className={[
        props.className,
        props.onClick ? styles.clickable : '',
      ].join(' ')}
      style={{
        ...props.bold ? { fontWeight: 'bold' } : {},
        ...props.italic ? { fontStyle: 'italic' } : {},
      }}
      onClick={props.onClick}
      title={props.title}
    >
      {props.children}
    </span>
  );
}
